export default __webpack_public_path__ + "static/media/mail.8d8c54ef.svg";